<template>
  <div class="quick-dropdown-filter position-relative" :class="$attrs.class">
    <button
      class=" dropdown-toggle btn btn-light d-flex align-items-center  gap-1 ps-3 pe-3"
      type="button"
      @click="toggleDropdown"
    >
      <strong>{{ label }} : </strong> <div class="flex-grow-1 text-start">
        {{ selected }}
      </div>
    </button>

    <ul
      v-if="isOpen"
      class="dropdown-menu show w-100"
      style="position: absolute; top: 70%; left: 0; z-index: 10;"
    >
      <li
        v-for="(option, index) in options"
        :key="index"
        @click="selectOption(option)"
        class="dropdown-item"
        :class="{
          option: option !== modelValue,
          'selected-option': option === modelValue,
        }"
        style="cursor: pointer;"
      >
        {{ option }}
      </li>
    </ul>
  </div>
</template>

<script>
export default {
  name: "QuickDropdownFilter",
  props: {
    label: {
      type: String,
      required: true,
    },
    options: {
      type: Array,
      required: true,
    },
    modelValue: {
      type: String,
      default: "",
    },
    defaultOption: {
      type: String,
      default: "All",
    },
  },
  emits: ["update:modelValue"],
  data() {
    return {
      isOpen: false,
      selectedStatus: "All",
    };
  },
  computed: {
    selected() {
      return this.modelValue || this.defaultOption;
    },
  },
  methods: {
    toggleDropdown() {
      this.isOpen = !this.isOpen;
    },
    selectOption(option) {
      this.$emit("update:modelValue", option);
      this.isOpen = false;
    },
    closeDropdownOnClickOutside(event) {
      if (!this.$el.contains(event.target)) {
        this.isOpen = false;
      }
    },
  },
  mounted() {
    document.addEventListener("click", this.closeDropdownOnClickOutside);
  },
  unmounted() {
    document.removeEventListener("click", this.closeDropdownOnClickOutside);
  },
};
</script>

<style>
.quick-dropdown-filter {
  border: solid 1px #ced4da;
  border-radius: 6px;
  background: #fff;
  padding: 0rem;
}
.dropdown-toggle {
  background: inherit;
  border: none;
  font-size: 14px;
  color: #717171;
  padding: 0;
  width: 100%;
  min-height: 44px;
}
.dropdown-toggle:hover, .dropdown-toggle:active{
 background-color: #fff;
   color: #717171;
}
.dropdown-toggle strong {
  font-weight: 500;
}
.quick-dropdown-filter .dropdown-menu {
  padding: 0;
  max-height: 250px;
  overflow-y: auto;
  min-width: 100%;

}
.quick-dropdown-filter .dropdown-item {
  font-size: 14px;
  padding: 0.3rem 0.75rem;
      white-space: normal;
    word-break: break-word;
    overflow-wrap: anywhere;
}
.quick-dropdown-filter .dropdown-item:first-child {
  border-bottom: solid 1px #ced4da;
}
.selected-option {
  color: #03c6ec;
  font-weight: 400;
}
.option {
  font-weight: 400;
  color: #717171;
}
.quick-dropdown-filter .dropdown-item:active{
  background-color: #03c6ec;
  color: #fff;
}
</style>
